var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoStandardResponsibleGaming = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29362",
    "data-name": "Group 29362",
    transform: "translate(75.001 -384.501)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47367",
    "data-name": "Path 47367",
    d: "M-67.115,393.171a4.183,4.183,0,0,0,3.061-1.271,4.2,4.2,0,0,0,1.269-3.064,4.2,4.2,0,0,0-1.27-3.065,4.326,4.326,0,0,0-6.117-.006l-.006.006a4.2,4.2,0,0,0-1.268,3.065,4.2,4.2,0,0,0,1.269,3.064A4.187,4.187,0,0,0-67.115,393.171Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48563",
    "data-name": "Path 48563",
    d: "M-59.042,398.34A10.423,10.423,0,0,0-59.2,397.2a8.385,8.385,0,0,0-.3-1.143,5.423,5.423,0,0,0-.5-1.066,4.071,4.071,0,0,0-.755-.924,3.376,3.376,0,0,0-1.085-.64,3.952,3.952,0,0,0-1.386-.235,1.447,1.447,0,0,0-.746.3c-.225.138-.489.3-.782.473a4.67,4.67,0,0,1-1.012.418,4.177,4.177,0,0,1-2.475,0,4.621,4.621,0,0,1-1.011-.418c-.292-.175-.555-.334-.783-.474a1.454,1.454,0,0,0-.747-.3,3.976,3.976,0,0,0-1.386.236,3.369,3.369,0,0,0-1.085.64,4.071,4.071,0,0,0-.755.924,5.548,5.548,0,0,0-.5,1.067,8.4,8.4,0,0,0-.3,1.142,9.972,9.972,0,0,0-.156,1.138c-.026.344-.039.7-.039,1.063a2.9,2.9,0,0,0,.946,2.261,3.541,3.541,0,0,0,2.437.834h9.232a3.541,3.541,0,0,0,2.437-.834A2.89,2.89,0,0,0-59,399.4C-59,399.04-59.017,398.683-59.042,398.34Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoStandardResponsibleGaming);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_standard_responsible_gaming.7496e6d5aa76bbfa5389c466aee48eb1.svg";